module.exports = __webpack_public_path__ + "static/media/insta.85b1c9f8.svg";